import { useMutation } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { ExportParticipants } from '../mutations/exportParticipants.mutation';
import type { ExportParticipantsMutation, ExportParticipantsMutationVariables } from '../types';

export const useExportParticipantsMutation = (
  options?: MutationOptions<ExportParticipantsMutation, ExportParticipantsMutationVariables>,
) => {
  return useMutation(gqlFetcher(ExportParticipants), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);
    },
  });
};
